module.exports = __webpack_public_path__ + "static/media/Assured_Quality.8ee73414.svg";